import React, { CSSProperties, useState, useEffect } from "react";
import Layout from "../../Layout";
import CatalogsLayout from "Components/CatalogsLayout";
import Grid, {
  TextFilter,
  SelectColumnFilter,
  NumberFilter,
} from "Components/Grid";
import CatalogsModal from "Components/CatalogsModal";
import Buttons from "../../Components/Buttons";
import { useSelector } from "react-redux";
import { getBrands, addBrand, updateBrand } from "actions/marca";
import FormMarca from "Forms/Marca";
import { IBrand } from "Interfaces/IBrand";
import ConfirmationModal from "Components/ConfirmationModal";
import { validateForm } from "../../utils";
import { getBrandsSC } from "actions/sc";

const Marca = () => {
  const defaultItem = {
    idMarca: 0,
    idMarcaSc: 0,
    codigoMarca: "",
    marca: "",
    logo: "",
    idEstatus: 1,
  };

  const [title] = useState("Marcas");
  const [open, setOpen] = useState<boolean>(false);
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const [action, setAction] = useState<string>("");
  const [brands, setBrands] = useState<any>();
  const [errors, setErrors] = useState<IBrand>({});
  const [formValues, setFormValues] = useState<any>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingGrid, setIsLoadingGrid] = useState<boolean>(true);

  const { catalogs } = useSelector((state: any) => state.theme);
  const { btnSimple } = useSelector((state: any) => state.theme);
  const [brandsSc, setBrandsSc] = React.useState([]);
  const styles: CSSProperties = {
    fontSize: `clamp(1.6rem, 2.5vw, 2rem)`,
    backgroundColor: catalogs.background,
  };

  const loadBrands = () => {
    getBrands(0).then((res) => {
      if (res) setBrands(res);
      setIsLoadingGrid(false);
    });
  };

  const handleBrands = () => {
    getBrandsSC().then((res) => {
      if (res) {
        res.unshift({
          idMarca: 0,
          descrMarca: "Seleccionar",
        });
        setBrandsSc(
          res.map((e: any) => {
            return {
              value: e.idMarca,
              text: e.descrMarca,
            };
          })
        );
      }
    });
  };

  useEffect(() => {
    loadBrands();
    handleBrands();
  }, []);

  const handleCancelConfirm = () => {
    setOpenConfirm(false);
    loadBrands();
  };

  const handleAddClick = () => {
    setAction("add");
    setErrors({});
    setFormValues(defaultItem);
    setOpen(true);
  };

  const handleView = (item: any) => {
    setAction("view");
    setFormValues(item);
    setOpen(true);
  };

  const handleEdit = (item: any) => {
    setAction("edit");
    setErrors({});
    setFormValues(item);
    setOpen(true);
  };

  const handleStatus = (item: any) => {
    item.idEstatus = item.idEstatus === 1 ? 0 : 1;
    setFormValues(item);
    setOpenConfirm(true);
  };

  const handleConfirm = () => {
    setIsLoading(true);
    let form = new FormData();
    for (let key in formValues) {
      form.append(key, formValues[key]);
    }
    updateBrand(formValues.idMarca, form, true).then((res) => {
      if (res) {
        loadBrands();
        setOpenConfirm(false);
        setFormValues({});
      }
      setIsLoading(false);
    });
  };

  const handleOnChange = (e: any) => {
    let value = e.target.value;
    let id = e.target.id;

    let itemError: any = errors;
    delete itemError[id];
    setErrors(itemError);

    if (value && id === "idMarcaSc") {
      let findMarca: any = brandsSc.find((item: any) => item.value == value);
      if (findMarca) {
        setFormValues({ ...formValues, marca: findMarca.text, [id]: value });
      }
    } else {
      setFormValues({
        ...formValues,
        [id === "_inputFile" ? "imagen" : id]:
          id === "_inputFile" ? e.target.files[0] : value,
        [id === "_inputFile" ? "logo" : id]:
          id === "_inputFile" ? e.target.files[0].name : value,
      });
    }
  };

  const handleAccept = () => {
    if (!handleValidation()) {
      return false;
    }
    setIsLoading(true);
    if (action === "add") {
      let form = new FormData();
      for (let key in formValues) {
        form.append(key, formValues[key]);
      }
      addBrand(form).then((res) => {
        if (res) {
          loadBrands();
          setOpen(false);
          setFormValues({});
        }
        setIsLoading(false);
      });
    }
    if (action === "edit") {
      let form = new FormData();
      for (let key in formValues) {
        form.append(key, formValues[key]);
      }
      updateBrand(formValues.idMarca, form).then((res) => {
        if (res) {
          loadBrands();
          setOpen(false);
          setFormValues({});
        }
        setIsLoading(false);
      });
    }
  };

  const handleValidation = () => {
    let isValid = validateForm({
      schema: {
        idMarcaSc: { message: "Selecciona la marca SC" },
        marca: { message: "Ingrese el alias" },
        codigoMarca: { message: "Ingrese el código" },
        imagen: {
          message: "Selecciona una imagen",
          optional: true,
          validate: (value: any) => {
            let rgx = /\.(gif|jpe?g|png)$/i;
            let match = value.name.match(rgx);

            if (match === null) {
              return {
                valid: false,
                message: "Formato de imagen no válido (.png .jpg)",
              };
            }

            if (parseFloat((value.size / (1024 * 1024)).toFixed(2)) > 5) {
              return {
                valid: false,
                message: "El peso de la imagen rebasa los 5MB soportados",
              };
            }

            return {
              valid: true,
              message: "",
            };
          },
        },
      },
      values: formValues,
    });
    if (Object.keys(isValid).length) {
      setErrors({ ...isValid });
      return false;
    }
    return true;
  };

  const handleCancel = () => {
    setOpen(false);
    loadBrands();
  };

  const columns = [
    {
      accessor: "idMarca",
      Header: "ID",
      Filter: TextFilter,
      filter: "text",
    },
    {
      accessor: "marca",
      Header: "Marca",
      Filter: TextFilter,
      filter: "text",
    },
    {
      accessor: "codigoMarca",
      Header: "Código",
      Filter: TextFilter,
      filter: "text",
    },
    {
      accessor: "idMarcaSc",
      Header: "ID SC",
      Filter: TextFilter,
      filter: "text",
    },
    {
      accessor: "estatus",
      Header: "Estatus",
      Filter: SelectColumnFilter,
      filter: "includes",
    },
  ];

  const config: any = {
    actions: [
      {
        action: "view",
        tooltip: "Detalles",
        visible: true,
        handle: handleView,
        color: "#0079ab",
        icon: "search",
      },
      {
        action: "edit",
        tooltip: "Editar",
        visible: true,
        handle: handleEdit,
        color: "#ffb300",
        icon: "edit",
      },
      {
        action: "status",
        tooltip: "Estatus",
        visible: true,
        handle: handleStatus,
        color: "#00a176",
        icon: "check",
        isStatus: "idEstatus",
        colorNegative: "#f15642",
        iconNegative: "clear",
      },
    ],
  };

  return (
    <Layout theme={styles}>
      <>
        <CatalogsLayout bannerTitle={title}>
          <>
            <Grid columns={columns} data={brands || []} config={config} isLoading={isLoadingGrid}>
              <Buttons
                title={"Nueva Marca"}
                type={"add-catalog"}
                config={btnSimple}
                handleClick={handleAddClick}
              />
            </Grid>
            {open && (
              <CatalogsModal
                open={open}
                action={action}
                title={title}
                modalSize={action === "view" ? "md" : "lg"}
                isLoading={isLoading}
                handleAcceptClick={handleAccept}
                handleCancelClick={handleCancel}
              >
                <FormMarca
                  item={formValues}
                  action={action}
                  errors={errors}
                  handleOnChange={handleOnChange}
                  options={{
                    marcaSc: brandsSc,
                  }}
                />
              </CatalogsModal>
            )}
            {openConfirm && (
              <ConfirmationModal
                open={openConfirm}
                description={`¿Está seguro de ${formValues.idEstatus === 1 ? "activar" : "desactivar"
                  } la marca ${formValues.marca}?`}
                modalSize={"sm"}
                isLoading={isLoading}
                handleConfirmClick={handleConfirm}
                handleCancelClick={handleCancelConfirm}
              ></ConfirmationModal>
            )}
          </>
        </CatalogsLayout>
      </>
    </Layout>
  );
};

export default Marca;
